// extracted by mini-css-extract-plugin
export default {"DeleteClientTagDialog":"DeleteClientTagDialog_DeleteClientTagDialog__XEnpr"};